import React, { Component } from 'react';
import request from 'superagent';
import { Base64 } from 'js-base64';
import CopyToClipboard from 'react-copy-to-clipboard';
import { message, Input, Button, Modal } from 'antd';
import Spinner from '../components/Spinner';

message.config({
  duration: 4,
});

const style = {
  save: {
    position: 'fixed',
    border: 'none',
    backgroundColor: 'Transparent',
    backgroundRepeat: 'no-repeat',
    right: 30,
    top: window.innerWidth > 600 ? 20 : window.innerHeight * 0.90,
    zIndex: 10,
    fontSize: '2em',
    color: '#8F685B',
    textDecoration: 'underline',
  },
  copy: {
    fontSize: '1em',
    border: 'none',
    backgroundColor: 'Transparent',
    backgroundRepeat: 'no-repeat',
    marginTop: 5,
    paddingTop: 25,
    paddingBottom: 20,
    textDecoration: 'underline',
    width: '100%',
  },
  dialog: {
    backgroundColor: '#00897B',
    color: '#ffffff',
    width: window.innerWidth > 600 ? '30%' : window.innerWidth * 0.8,
    height: '130px',
    marginTop: '-65px',
    marginLeft: window.innerWidth > 600 ? '-15%' : window.innerWidth * -0.45,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  shortCodeInput: {
    alignItems: 'center',

    marginTop: 25,
    width: '100%',
    height: '20px',
    fontSize: '1em',
  },
};

const phraseToArray = (lines, display, width, height, fontSize) => {
  let newLines = [];
  let calcSize = fontSize;

  const words = display.replace(/^\n/, '').replace(/\n/g, ' ').split(' ');

  /*
  console.log(`'${words}'`);

  console.log(`display: ${display}`);
  console.log(`words: ${words}`);
  */

  newLines.push(words.join(' '));

  for (let wordsPerLine = 1; wordsPerLine <= words.length; wordsPerLine++) {
    let line = [];
    newLines = [];

    /*
    console.log('=========');
    */

    for (let j = 0; j < words.length; j++) {
      if ((words[j].length + 1 + line.join(' ').length) * calcSize > (0.9 * width)) {

        /*
        console.log(`1: line=${line}`);
        */

        if (line.length > 0) {
            newLines.push(line.join(' '));
            line = [];
        }
      }

      if (line.length === wordsPerLine) {

        /*
        console.log(`2: line=${line}`);
        */

        newLines.push(line.join(' '));
        line = [];
      }

      /*
      console.log(`3: word[${j}] = ${words[j]}`);
      */

      line.push(words[j]);
    }
    if (line.length > 0) {

      /*
      console.log(`4: line=${line}`);
      */

      newLines.push(line.join(' '));
      line = [];
    }

    calcSize = 0.60 * height / newLines.length;
    /*
    console.log(`1: cs=${calcSize}`);
    */

    const longestLineLength = Math.max.apply(Math, newLines.map(row => row.length));

    if (calcSize * longestLineLength > width ) {
      calcSize = width / longestLineLength;
      /*
      console.log(`2: cs=${calcSize}`);
      */
    }
  } 

  return { lines: newLines, fontSize: calcSize };
}

class EmlargeTextArea extends Component {
  constructor(props) {
    super(props);

    const width = window.innerWidth;
    const height = window.innerHeight; 

    const phrase = 'type here';
    const { lines, fontSize } = phraseToArray([], phrase, width, height, 24);
    const display = '';

    this.state = {
      spinnerVisible: false,
      modalVisible: false,
      shortCode: '',
      lines,
      display,
      width,
      height,
      style: {
        textarea: {
          margin: 0,
          padding: 0,
          display: 'block',

          border: 'none',
          fontSize,
          height,
          width,
        },
      },
    };
  }

  componentDidMount() {

    if (this.props.shortCode === undefined) {
      return;
    }
    if (this.props.shortCode.length === 0) {
      return;
    }

    this.setState({ spinnerVisible: true });

    const baseurl = 'https://api.emlarge.com';
    request
    .get(`${baseurl}/${this.props.shortCode}`)
    .set('Accept', 'application/json')
    .then(res => {

      const phrase = Base64.decode(res.body.Phrase);

      const height = this.state.height;
      const width = this.state.width;
      const { lines, fontSize } = phraseToArray(this.state.lines, phrase, width, height, 24);
      const display = lines.join('\n');
      const style = JSON.parse(JSON.stringify(this.state.style));
      style.textarea.fontSize = fontSize;

      this.setState({
        lines,
        height,
        width,
        display,
        style,
        spinnerVisible: false,
      });
    }, err => {
      this.setState({ spinnerVisible: false });
      message.error('That message has already been viewed and deleted!');
    });

  }

  _handleChange(event) {
    const phrase = event.target.value;
    const { lines, fontSize } = phraseToArray(this.state.lines, phrase, this.state.width, this.state.height, 24);

    const style = JSON.parse(JSON.stringify(this.state.style));
    style.textarea.fontSize = fontSize;

    this.setState({ 
      lines,
      display: lines.join('\n'), 
      style,
    });
  }

  _handleOk(e) {
    this.setState({
      modalVisible: false,
    }); 
  }

  _handleSave() {
    if (this.state.display.length === 0) {
      this.setState({
        modalVisible: true,
      });
      return;
    }

    this.setState({ spinnerVisible: true });

    const url = 'https://api.emlarge.com';
    request
    .post(url)
    .send(`phrase=${Base64.encode(this.state.display)}`)
    .set('Accept', 'application/json')
    .then(res => {
      const shortCode = JSON.parse(res.text).item.Item.ShortCode;

      this.setState({
        shortCode,
        modalVisible: true,
        spinnerVisible: false,
      });
    }, err => {
      this.setState({ spinnerVisible: false });
      message.error('Failed to safe! Please try again.');
    });
  }

  render() {
    return (
      <div>
        <Spinner visible={this.state.spinnerVisible} />
        <Modal visible={this.state.modalVisible}
          onOk={() => this._handleOk()} 
          onCancel={() => this._handleOk()}
          footer={null}
        >
          <Input 
            type="url" 
            readOnly
            ref="urlInput"
            style={style.shortCodeInput}
            value={`https://www.emlarge.com/#${this.state.shortCode}`} 
          />
          <CopyToClipboard text={`https://www.emlarge.com/#${this.state.shortCode}`}>
            <Button onClick={() => {}} style={style.copy}>
              Copy this address!
            </Button>
          </CopyToClipboard>
          
        </Modal>
        <Button onClick={() => this._handleSave()} style={style.save} icon="share-alt" />
        <textarea 
          style={this.state.style.textarea} 
          type="text" 
          value={this.state.display} 
          onChange={(event) => this._handleChange(event)} 
          placeholder="type here"
        />
      </div>
    );
  }

}

export default EmlargeTextArea;



// WEBPACK FOOTER //
// ./src/components/EmlargeTextArea.js